import "./HomePage.css";
import "./HomePageHalloween.css"
import React from "react";
import { useNavigate } from "react-router-dom";


import Header from "./Header";
import PersonalStory from "./PersonalStory";
import Customersay from "./Customersay";
import SEO from "./SEO";
import LocalBusinessSchema from "./LocalBusinessSchema";
import ClientGallery from "./ClientGallery"; // NEW: client photo access pop-up



function HomePage() {
  const navigate = useNavigate();


  const goToBooking = () => {
    navigate("/booking");
  };


  return (
    <>
      <SEO
        title="Portrait Photographer West Los Angeles | West LA Portraits"
        description="West LA Portraits creates modern, timeless portraits for professionals, creatives, and families across West Los Angeles, Santa Monica, Brentwood, and Culver City."
        url="https://www.westlaportraits.com/"
        image="https://www.westlaportraits.com/og-home.jpg"
      />


      <LocalBusinessSchema />


      <main className="homepage">
        {/* Hero: visually clean image carousel, with an accessible SEO heading */}
        <section className="homepage-hero">
          <div className="section-inner section-inner--hero">
            <h1 className="sr-only">
              Portrait Photography in West Los Angeles
            </h1>
            <Header />
          </div>
        </section>


        {/* About / personal introduction */}
        <section className="homepage-story">
          <PersonalStory />
        </section>


        {/* Client testimonials */}
        <section className="homepage-testimonials">
          <div className="section-shell">
            <div className="homepage-section-head">
              <p className="homepage-section-kicker">Client Notes</p>


              <h2 className="homepage-section-title">
                What it feels like to work with us 
              </h2>
            </div>


            <Customersay />
          </div>
        </section>


        {/* NEW: Client gallery access, where clients open their Dropbox photos */}
        <section className="homepage-client-gallery">
          <div className="section-shell">
            <div className="homepage-section-head">
              <p className="homepage-section-kicker">For Clients</p>


              <h2 className="homepage-section-title">
                BIG BOO IMAGES
              </h2>
            </div>


            <p className="homepage-client-gallery-text">
              Enter the gallery code from your email to view and download your images.
            </p>


            <ClientGallery />
          </div>
        </section>


        {/* Persistent booking call to action */}
        <button
          type="button"
          className="floating-booking"
          onClick={goToBooking}
          aria-label="Book a photography session"
        >
          <span>Book a session</span>
        </button>
      </main>
    </>
  );
}


export default HomePage;
